<mat-form-field class="w-100" [floatLabel]="floatLabel" [color]="color" [appearance]="theme">
  <mat-label>{{label | translate}}</mat-label>

  <mat-select placeholder="{{'general.selection' | translate }}"  id="{{ matSelectId }}" [disabled]="disabled" [(ngModel)]="selectedValue" (ngModelChange)="updateSelection()"
    [multiple]="multipleSelect" panelClass="full-option-size">

    @if (!multipleSelect) {
      <mat-option [value]="null">--{{ 'general.nonSpecifie' | translate}}--</mat-option>
    }

    @for (item of items; track item) {
      <mat-option [value]="item">
        @if (propertyTranslatable) {
          {{item[displayProperty] | translate}}
        }
        @if (!propertyTranslatable) {
          {{ (displayProperty === '') ? item : item[displayProperty] }}
        }
      </mat-option>
    }
  </mat-select>
</mat-form-field>


